// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import config from '@/defaultSettings'
import util from './utils/util'
import './plugins/vant'
import 'animate.css'
import './utils/style/comm.less'
// eslint-disable-next-line
import './utils/vconsole'
import './permission'
import moment from 'moment'
import vTrace from './utils/vTrace'
import vLongPress from './utils/longPress.js'
// 全局组件
import customCom from '@/components'
import TipsDialog from '@/components/TipsDialog'
import {ACCESS_TOKEN, USER_INFO} from './store/mutation-types'
// 使用use 使用
Vue.prototype.$moment = moment
moment.locale('zh-CN')
Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(customCom)
Vue.use(TipsDialog)
Vue.prototype.$track = vTrace
Vue.prototype.$longPress = vLongPress
Vue.prototype.$utils = util
window.document.title = 'iEP-中国电生理术者充电站'

// 配置 Vue 忽略的自定义元素
Vue.config.ignoredElements = [
  'wx-open-launch-weapp', // 忽略微信开放标签
]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  mounted() {
    store.commit('SET_INFO', Vue.ls.get(USER_INFO) || {})
    store.commit('SET_ACCESS_TOKEN', Vue.ls.get(ACCESS_TOKEN) || '')
  },
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js